import AccessTimeIcon from '@mui/icons-material/AccessTime';
import DoneIcon from '@mui/icons-material/Done';
import DoneAllIcon from '@mui/icons-material/DoneAll';
// import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import ReplyIcon from '@mui/icons-material/Reply';
import { Box, Grid, Menu, MenuItem, Paper, Typography } from '@mui/material';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
// import PersonOffOutlinedIcon from '@mui/icons-material/PersonOffOutlined';
import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { timeFormattingByDate } from '../helpers/date-helpers';
import {
  setIsOpenCancelModal,
  setIsOpenFullscreenPicture,
  setIsOpenResendingModal
} from '../redux/mainReducer';
import { StyledTitle } from './StyledComponents';
import { MoreHoriz } from '@mui/icons-material';
import ServiceCard from './ServiceCard';
import PostCard from './PostCard';
import UserCard from './UserCard';

//Material
function srcset(image, size, rows = 1, cols = 1) {
  return {
    src: image,
    srcSet: image
    //?w=${size * cols}&h=${
    // size * rows
    // }&fit=crop&auto=format&dpr=2 2x
  };
}

function ChatMessage({
  imgs,
  setText,
  setShowedImg,
  setSliderStartIdx,
  deleteMessage,
  selectedChat,
  message,
  setMessageSelected,
  setIsEditMessage,
  setIsSendingPic,
  setIsReplyMessage,
  setIsResendMessage,
  index,
  userData,
  setUsersForResending
}) {
  const [anchorEl, setAnchorEl] = useState(null);

  const [itemData, setItemData] = useState([]);
  const [includedObject, setIncludedObject] = useState(null);
  // const isOpenDeleteModal = useSelector((state) => state.global.isOpenDeleteModal);
  const dispatch = useDispatch();
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const language = useSelector((state) => state.Intl.locale);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setMessageSelected(message.id);
    setIsEditMessage(false);
    setText('');
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  // eslint-disable-next-line

  // function getFileFromBase64(string64, fileName) {
  //   const trimmedString = string64.replace('dataimage/jpegbase64', '');
  //   const imageContent = atob(trimmedString);
  //   const buffer = new ArrayBuffer(imageContent.length);
  //   const view = new Uint8Array(buffer);

  //   for (let n = 0; n < imageContent.length; n++) {
  //     view[n] = imageContent.charCodeAt(n);
  //   }
  //   const type = 'image/jpeg';
  //   const blob = new Blob([buffer], { type });
  //   return new File([blob], fileName, { lastModified: new Date().getTime(), type });
  // }
  const setPhotoPosition = (index, length) => {
    if (length === 2) {
      return 3;
    } else if (length === 3) {
      return 2;
    } else if (length === 4) {
      return 3;
    } else if (length === 5) {
      switch (index) {
        case 0:
          return 2;
        case 1:
          return 2;
        case 2:
          return 2;
        case 3:
          return 3;
        case 4:
          return 3;
        default:
          return;
      }
    } else if (length === 6) {
      return 2;
    } else if (length === 7) {
      switch (index) {
        case 0:
          return 3;
        case 1:
          return 3;
        case 2:
          return 2;
        case 3:
          return 2;
        case 4:
          return 2;
        case 5:
          return 3;
        case 6:
          return 3;
        default:
          return;
      }
    } else if (length === 8) {
      switch (index) {
        case 0:
          return 2;
        case 1:
          return 2;
        case 2:
          return 2;
        case 3:
          return 3;
        case 4:
          return 3;
        case 5:
          return 2;
        case 6:
          return 2;
        case 7:
          return 2;
        default:
          return;
      }
    } else if (length === 9) {
      return 2;
    } else if (length === 10) {
      switch (index) {
        case 0:
          return 3;
        case 1:
          return 3;
        case 2:
          return 2;
        case 3:
          return 2;
        case 4:
          return 2;
        case 5:
          return 3;
        case 6:
          return 3;
        case 7:
          return 2;
        case 8:
          return 2;
        case 9:
          return 2;
        default:
          return;
      }
    } else {
      return 6;
    }
  };

  useEffect(() => {
    if (message && message?.photoUrls && message?.photoUrls.length !== 0) {
      setItemData([
        ...message.photoUrls.map((photo, index) => ({
          img: photo,
          title: 'Breakfast',
          rows: setPhotoPosition(index, message.photoUrls.length),
          cols: setPhotoPosition(index, message.photoUrls.length)
        }))
      ]);
    }
    if (message?.forwardedMessage && message?.forwardedMessage?.abstractMessageWithDTO?.photoUrls) {
      setItemData([
        ...message?.forwardedMessage?.abstractMessageWithDTO?.photoUrls.map((photo, index) => ({
          img: photo,
          title: 'Breakfast',
          rows: setPhotoPosition(
            index,
            message?.forwardedMessage.abstractMessageWithDTO.photoUrls.length
          ),
          cols: setPhotoPosition(
            index,
            message?.forwardedMessage.abstractMessageWithDTO.photoUrls.length
          )
        }))
      ]);
    }
    if (message?.type === 'user') {
      setIncludedObject(message.userDTO);
    }
    if (message?.type === 'service') {
      setIncludedObject(message.servicePostDTO);
    }
    if (message?.type === 'post') {
      setIncludedObject(message.postDTO);
    }
    return () => setItemData([]);
    // eslint-disable-next-line
  }, [message]);

  return (
    <React.Fragment key={`chatMessage${index}container`}>
      {message?.senderId === userData?.id ? (
        <Grid container key={`chatMessage${index}`} id={message.id} sx={{ pb: '20px' }}>
          <Grid item xs={2} sm={6} />
          <Grid
            item
            xs={10}
            sm={6}
            sx={{
              p: 1,
              display: 'flex',
              alignItems: 'end',
              justifyContent: 'end',
              position: 'relative'
            }}
          >
            <Box
              id="1"
              sx={{
                padding: '8px',
                borderRadius: '10px 10px 0px 10px',
                background: includedObject || message?.forwardedMessage ? 'transparent' : '#E2F2FF',
                fontSize: '14px',
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                flexDirection: 'column',
                position: 'relative'
              }}
            >
              <>
                <ReplyIcon
                  sx={{ position: 'absolute', left: '-30px', bottom: '0px', cusor: 'pointer' }}
                  onClick={(event) => {
                    event.stopPropagation();
                    event.preventDefault();
                    setIsEditMessage(true);
                    setIsSendingPic(false);
                    setIsReplyMessage(true);
                    setIsResendMessage(false);
                    setText('');
                    setMessageSelected(message.id);
                    handleClose();
                  }}
                />
                <MoreHoriz
                  // key={`${message.text}${Math.random()}`}
                  onClick={(event) => handleClick(event)}
                  sx={{
                    ml: 1,
                    cursor: 'pointer',
                    ':hover': { color: '#60A5DF' },
                    zIndex: '99',
                    fontSize: '24px',
                    position: 'absolute',
                    left: '-65px',
                    bottom: '0px',
                    borderRadius: '50px',
                    p: '3px',
                    boxShadow: ' 0px 0px 15px -5px #00000026'
                  }}
                />
                <Menu
                  anchorEl={anchorEl}
                  id="action-menu"
                  open={open}
                  onClose={handleClose}
                  onMouseLeave={handleClose}
                  PaperProps={{
                    elevation: 0,
                    sx: {
                      overflow: 'hidden',
                      boxShadow: '0px 0px 15px -5px #00000026',
                      borderRadius: '5px',

                      paddingTop: '10px',
                      paddingLeft: '20px',
                      paddingRight: '20px',
                      mt: 1
                    }
                  }}
                  autoFocus={false}
                  transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                  anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                >
                  <MenuItem
                    onClick={(event) => {
                      event.stopPropagation();
                      event.preventDefault();
                      setIsEditMessage(true);
                      setIsSendingPic(false);
                      setIsReplyMessage(true);
                      setIsResendMessage(false);
                      handleClose();
                    }}
                    sx={{
                      borderRadius: '4px',
                      ':hover': { backgroundColor: '#E2F2FF' },
                      fontFamily: 'FixelText-Medium',
                      fontWeight: '500',
                      pl: '12px !important',
                      m: '2px 0px !important'
                    }}
                  >
                    <Typography component="p" fontSize={16} lineHeight="18px" fontWeight={400}>
                      Відповісти
                    </Typography>
                  </MenuItem>
                  <MenuItem
                    onClick={(event) => {
                      event.stopPropagation();
                      event.preventDefault();
                      dispatch(
                        setIsOpenResendingModal({
                          isOpen: true,
                          id: null,
                          type: null,
                          func: setUsersForResending
                        })
                      );
                      setIsEditMessage(false);
                      setIsSendingPic(false);
                      setIsResendMessage(true);
                      setIsReplyMessage(false);
                      handleClose();
                    }}
                    sx={{
                      borderRadius: '4px',
                      ':hover': { backgroundColor: '#E2F2FF' },
                      fontFamily: 'FixelText-Medium',
                      fontWeight: '500',
                      pl: '12px !important',
                      m: '2px 0px !important'
                    }}
                  >
                    <Typography component="p" fontSize={16} lineHeight="18px" fontWeight={400}>
                      Відправити
                    </Typography>
                  </MenuItem>
                  <MenuItem
                    onClick={(event) => {
                      event.stopPropagation();
                      event.preventDefault();
                      setIsEditMessage(true);
                      // THIS NEEDED IF MESSAGE HAD A PHOTOS !!!!!!!!!
                      if (message?.type && message?.type === 'photo') {
                        setIsSendingPic(true);
                      }
                      setIsReplyMessage(false);
                      setIsResendMessage(false);
                      handleClose();
                    }}
                    sx={{
                      borderRadius: '4px',
                      ':hover': { backgroundColor: '#E2F2FF' },
                      fontFamily: 'FixelText-Medium',
                      fontWeight: '500',
                      pl: '12px !important',
                      m: '2px 0px !important'
                    }}
                  >
                    <Typography component="p" fontSize={16} lineHeight="18px" fontWeight={400}>
                      Редагувати
                    </Typography>
                  </MenuItem>
                  {!message?.messageIsRead && (
                    <MenuItem
                      onClick={(event) => {
                        event.stopPropagation();
                        event.preventDefault();
                        dispatch(
                          setIsOpenCancelModal({
                            isOpen: true,
                            func: deleteMessage,
                            id: message.id
                          })
                        );
                        handleClose();
                      }}
                      sx={{
                        borderRadius: '4px',
                        ':hover': { backgroundColor: '#FFE5E5' },

                        fontFamily: 'FixelText-Medium',
                        fontWeight: '500',
                        color: '#F64D36',

                        pl: '12px !important',
                        m: '2px 0px !important'
                      }}
                    >
                      <Typography component="p" fontSize={16} lineHeight="18px" fontWeight={400}>
                        Відмінити відправку
                      </Typography>
                    </MenuItem>
                  )}
                </Menu>
              </>
              {includedObject ? (
                <>
                  {message.type === 'user' ? (
                    <Paper
                      sx={{
                        p: '0px 0px 10px',
                        backgroundColor: 'transparent',
                        minWidth: { xs: '250px', sm: '270px' },
                        ml: 'auto'
                      }}
                    >
                      <UserCard el={includedObject} noWidth={true} />
                    </Paper>
                  ) : null}
                  {message.type === 'service' ? (
                    <Paper sx={{ p: '0px 0px 10px', backgroundColor: 'transparent', ml: 'auto' }}>
                      <ServiceCard el={includedObject} isServicePage={true} />
                    </Paper>
                  ) : null}
                  {message.type === 'post' ? (
                    <Paper sx={{ p: '0px 0px 10px', ml: 'auto', backgroundColor: 'transparent' }}>
                      <PostCard el={includedObject} isChat={true} />
                    </Paper>
                  ) : null}
                </>
              ) : (
                <>
                  {message.type === 'post' ? (
                    <Paper sx={{ width: '279px', border: '1px solid #60A5DF', p: '12px' }}>
                      <Grid container>
                        <Grid
                          item
                          xs={12}
                          sx={{
                            height: 350,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center'
                          }}
                        >
                          <>
                            <StyledTitle
                              // maxWidth={800}
                              sx={{
                                lineHeight: '38px !important',
                                fontSize: '32px !important',
                                textTransform: 'initial !important',
                                margin: '0px auto !important'
                              }}
                              className="messageError-title"
                            >
                              йой!
                            </StyledTitle>
                            <Typography
                              sx={{
                                fontSize: '14px',
                                margin: '5px auto 0px',
                                width: '50%',
                                textAlign: 'center'
                              }}
                            >
                              На жаль, посту більше не існує
                            </Typography>
                          </>
                        </Grid>
                      </Grid>
                    </Paper>
                  ) : null}
                  {message.type === 'service' ? (
                    <Paper sx={{ width: '279px', p: '0px 0px 10px' }}>
                      <Grid container>
                        <Grid
                          item
                          xs={12}
                          sx={{
                            height: 350,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center'
                          }}
                        >
                          <>
                            <StyledTitle
                              // maxWidth={800}
                              sx={{
                                lineHeight: '38px !important',
                                fontSize: '32px !important',
                                textTransform: 'initial !important',
                                margin: '0px auto !important'
                              }}
                              className="messageError-title"
                            >
                              йой!
                            </StyledTitle>
                            <Typography
                              sx={{
                                fontSize: '14px',
                                margin: '5px auto 0px',
                                width: '50%',
                                textAlign: 'center'
                              }}
                            >
                              На жаль, товару більше не існує
                            </Typography>
                          </>
                        </Grid>
                      </Grid>
                    </Paper>
                  ) : null}
                  {message.type === 'user' ? (
                    <Paper sx={{ width: '279px', border: '1px solid #60A5DF', p: '12px' }}>
                      <Grid container>
                        <Grid
                          item
                          xs={12}
                          sx={{
                            height: 197,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center'
                          }}
                        >
                          <>
                            <StyledTitle
                              // maxWidth={800}
                              sx={{
                                lineHeight: '38px !important',
                                fontSize: '32px !important',
                                textTransform: 'initial !important',
                                margin: '0px auto !important'
                              }}
                              className="messageError-title"
                            >
                              йой!
                            </StyledTitle>
                            <Typography
                              sx={{
                                fontSize: '14px',
                                margin: '5px auto 0px',
                                width: '50%',
                                textAlign: 'center'
                              }}
                            >
                              На жаль, профіль більше не існує
                            </Typography>
                          </>
                        </Grid>
                      </Grid>
                    </Paper>
                  ) : null}
                </>
              )}
              {itemData.length !== 0 && (
                <>
                  {message?.forwardedMessage && (
                    <Grid container sx={{ width: '100%' }} spacing={1}>
                      <Grid item xs={10} sx={{ display: 'flex' }}>
                        <Typography
                          onClick={() =>
                            navigate(
                              `/${language}/user-page/${message.forwardedMessage?.userId}?type=posts`
                            )
                          }
                          variant="body2"
                          sx={{
                            fontSize: '14px',
                            fontWeight: '500',
                            cursor: 'pointer',
                            color: '#7C7C7C',
                            fontFamily: 'FixelText-Medium'
                          }}
                        >{`@${message.forwardedMessage?.nickname}`}</Typography>
                      </Grid>

                      {/* <Grid item sx={{ width: '41px' }} /> */}
                    </Grid>
                  )}
                  <ImageList
                    sx={{
                      // width: { xs: '250px', sm: '300px' },
                      // height: 'max-content',
                      mt: 0
                    }}
                    variant="quilted"
                    cols={6}
                    rowHeight={40}
                  >
                    {itemData.map((item, index) => (
                      <ImageListItem
                        key={`photo${index + message?.id}`}
                        onClick={() => {
                          setSliderStartIdx(index);
                          setShowedImg(itemData);
                          dispatch(setIsOpenFullscreenPicture(true));
                        }}
                        // key={`photo${item.img.lastModified}${message.id}`}
                        cols={item.cols || 1}
                        rows={item.rows || 1}
                      >
                        <img
                          style={{ borderRadius: '5px' }}
                          {...srcset(item.img, 50, item.rows, item.cols)}
                          alt={item.title}
                        />
                      </ImageListItem>
                    ))}
                  </ImageList>
                </>
              )}
              {message?.forwardedMessage?.abstractMessageWithDTO?.type === 'user' ||
              message?.forwardedMessage?.abstractMessageWithDTO?.type === 'service' ||
              message?.forwardedMessage?.abstractMessageWithDTO?.type === 'post' ? (
                <>
                  <Grid container sx={{ width: '100%' }} spacing={1}>
                    <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'end' }}>
                      <Typography
                        onClick={() =>
                          navigate(
                            `/${language}/user-page/${message.forwardedMessage?.userId}?type=posts`
                          )
                        }
                        variant="body2"
                        sx={{
                          fontSize: '14px',
                          fontWeight: '500',
                          cursor: 'pointer',
                          color: '#7C7C7C',
                          fontFamily: 'FixelText-Medium'
                        }}
                      >{`@${message.forwardedMessage?.nickname}`}</Typography>
                    </Grid>

                    {/* <Grid item sx={{ width: '41px' }} /> */}
                  </Grid>
                  {message?.forwardedMessage?.abstractMessageWithDTO?.type === 'user' && (
                    // <Grid item xs={10}>
                    <Paper
                      sx={{
                        p: '0px 0px 10px',
                        backgroundColor: 'transparent',
                        minWidth: { xs: '250px', sm: '270px' },
                        ml: 'auto'
                      }}
                    >
                      <UserCard
                        el={message?.forwardedMessage?.abstractMessageWithDTO?.userDTO}
                        noWidth={true}
                      />
                    </Paper>
                  )}
                  {message?.forwardedMessage?.abstractMessageWithDTO?.type === 'service' && (
                    <Paper
                      sx={{ p: '0px 0px 10px', mt: 0, backgroundColor: 'transparent', ml: 'auto' }}
                    >
                      <ServiceCard
                        isServicePage={true}
                        el={message?.forwardedMessage?.abstractMessageWithDTO?.servicePostDTO}
                      />
                    </Paper>
                  )}
                  {message?.forwardedMessage?.abstractMessageWithDTO?.type === 'post' && (
                    <Paper sx={{ p: '0px 0px 10px', ml: 'auto', backgroundColor: 'transparent' }}>
                      <PostCard
                        el={message?.forwardedMessage?.abstractMessageWithDTO?.postDTO}
                        isChat={true}
                      />
                    </Paper>
                  )}
                </>
              ) : null}
              {(message?.text?.length > 0 || message?.forwardedMessage) && (
                <Box
                  id="2"
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%'

                    // flexDirection:itemData.length!==0?'column':'row'
                  }}
                >
                  <Grid
                    container
                    sx={{
                      background: includedObject || message?.forwardedMessage ? '#E2F2FF' : 'none',
                      p: includedObject || message?.forwardedMessage ? '8px' : '0px',
                      borderRadius:
                        includedObject || message?.forwardedMessage ? '8px 8px 0px 8px' : '0px'
                    }}
                  >
                    {message.forwardedMessage && (
                      <Grid
                        container
                        sx={{
                          width: '100%',
                          borderRadius: '8px',
                          backgroundColor: ' #FFFFFF99',
                          m: 0
                        }}
                        spacing={1}
                      >
                        {!message?.forwardedMessage?.abstractMessageWithDTO?.photoUrls &&
                          message?.forwardedMessage?.abstractMessageWithDTO?.type !== 'user' &&
                          message?.forwardedMessage?.abstractMessageWithDTO?.type !== 'service' &&
                          message?.forwardedMessage?.abstractMessageWithDTO?.type !== 'post' && (
                            <>
                              <Grid item xs={12} sx={{ display: 'flex' }}>
                                <Typography
                                  onClick={() =>
                                    navigate(
                                      `/${language}/user-page/${message.forwardedMessage.userId}?type=posts`
                                    )
                                  }
                                  variant="body2"
                                  sx={{
                                    fontFamily: 'FixelText-Medium',
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    color: '#7C7C7C',
                                    cursor: 'pointer'
                                  }}
                                >{`@${message.forwardedMessage.nickname}`}</Typography>
                              </Grid>{' '}
                            </>
                          )}

                        <Grid
                          item
                          xs={12}
                          sx={{
                            wordBreak: 'break-word',
                            fontSize: '14px',

                            pb: 1,
                            mb: 1
                          }}
                        >
                          {message.forwardedMessage.abstractMessageWithDTO.text}
                        </Grid>
                      </Grid>
                    )}
                    {message.text.length !== 0 && (
                      <Grid item xs={message.forwardedMessage ? 10 : 12}>
                        <Typography
                          variant="body2"
                          sx={
                            message.forwardedMessage
                              ? {
                                  fontSize: { xs: '14px', sm: '14px' },
                                  wordBreak: 'break-word'
                                }
                              : {
                                  fontSize: { xs: '14px', sm: '14px' },
                                  wordBreak: 'break-word',
                                  textAlign: message?.type === 'photo' ? 'right' : 'left'
                                }
                          }
                        >
                          {message.text}
                        </Typography>
                      </Grid>
                    )}
                    {message?.isChanged && (
                      <Grid item xs={12}>
                        <Typography
                          variant="body2"
                          sx={{
                            fontSize: { xs: '12px', sm: '14px' },
                            wordBreak: 'break-word',
                            textAlign: 'left',
                            color: '#7C7C7C'
                          }}
                        >
                          (редаговано)
                        </Typography>
                      </Grid>
                    )}
                  </Grid>
                </Box>
              )}
            </Box>

            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                margin: 'auto',
                alignItems: 'end',
                position: 'absolute',
                bottom: '-15px',
                right: '10px'
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontSize: '14px',
                  fontFamily: 'FixelText-Regular',
                  color: '#7C7C7C',
                  marginRight: '5px',
                  marginTop: '0'
                }}
              >
                {timeFormattingByDate(new Date(message.sendingTime))}
              </Typography>
              {message?.id ? (
                <>
                  {!message?.messageIsRead ? (
                    <DoneIcon sx={{ fontSize: '19px', color: '#216BAA', mb: '2px' }} />
                  ) : (
                    <DoneAllIcon sx={{ fontSize: '19px', color: '#216BAA', mb: '2px' }} />
                  )}
                </>
              ) : (
                <AccessTimeIcon sx={{ color: '#c37b7b', fontSize: '19px', mb: '2px' }} />
              )}
            </div>
          </Grid>
        </Grid>
      ) : (
        <Grid
          container
          id={message?.id}
          key={`chatMessage${message?.id}`}
          sx={{ overflowAnchor: 'auto', pb: '20px' }}
        >
          <Grid
            item
            xs={10}
            sm={6}
            sx={{ p: 1, display: 'flex', alignItems: 'start', position: 'relative' }}
          >
            <Box
              id="3"
              sx={{
                // alignItems:'center !important',
                padding: '8px',
                borderRadius: '10px 10px 10px 0px',
                background: includedObject || message?.forwardedMessage ? 'transparent' : '#F5F4F4',
                fontSize: '14px',
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                flexDirection: 'column',
                position: 'relative'
              }}
            >
              {includedObject ? (
                <>
                  {message.type === 'user' ? (
                    <Paper
                      sx={{
                        p: '0px 0px 10px',
                        backgroundColor: 'transparent',
                        minWidth: { xs: '250px', sm: '270px' },
                        mr: 'auto'
                      }}
                    >
                      <UserCard el={includedObject} noWidth={true} />
                    </Paper>
                  ) : null}
                  {message.type === 'service' ? (
                    <Paper
                      sx={{
                        p: '0px 0px 10px',
                        backgroundColor: 'transparent',
                        mr: 'auto'
                      }}
                    >
                      <ServiceCard el={includedObject} isServicePage={true} />
                    </Paper>
                  ) : null}
                  {message.type === 'post' ? (
                    <Paper sx={{ p: '0px 0px 10px', backgroundColor: 'transparent' }}>
                      <PostCard el={includedObject} isChat={true} />
                    </Paper>
                  ) : null}
                </>
              ) : (
                <>
                  {message.type === 'post' ? (
                    <Paper sx={{ width: '279px', border: '1px solid #60A5DF', p: '12px' }}>
                      <Grid container>
                        <Grid
                          item
                          xs={12}
                          sx={{
                            height: 350,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center'
                          }}
                        >
                          <>
                            <StyledTitle
                              // maxWidth={800}
                              sx={{
                                lineHeight: '38px !important',
                                fontSize: '32px !important',
                                textTransform: 'initial !important',
                                margin: '0px auto !important'
                              }}
                              className="messageError-title"
                            >
                              йой!
                            </StyledTitle>
                            <Typography
                              sx={{
                                fontSize: '14px',
                                margin: '5px auto 0px',
                                width: '50%',
                                textAlign: 'center'
                              }}
                            >
                              На жаль, посту більше не існує
                            </Typography>
                          </>
                        </Grid>
                      </Grid>
                    </Paper>
                  ) : null}
                  {message.type === 'service' ? (
                    <Paper sx={{ width: '279px', p: '12px' }}>
                      <Grid container>
                        <Grid
                          item
                          xs={12}
                          sx={{
                            height: 350,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center'
                          }}
                        >
                          <>
                            <StyledTitle
                              // maxWidth={800}
                              sx={{
                                lineHeight: '38px !important',
                                fontSize: '32px !important',
                                textTransform: 'initial !important',
                                margin: '0px auto !important'
                              }}
                              className="messageError-title"
                            >
                              йой!
                            </StyledTitle>
                            <Typography
                              sx={{
                                fontSize: '14px',
                                margin: '5px auto 0px',
                                width: '50%',
                                textAlign: 'center'
                              }}
                            >
                              На жаль, товару більше не існує
                            </Typography>
                          </>
                        </Grid>
                      </Grid>
                    </Paper>
                  ) : null}
                  {message.type === 'user' ? (
                    <Paper sx={{ width: '279px', border: '1px solid #60A5DF', p: '12px' }}>
                      <Grid container>
                        <Grid
                          item
                          xs={12}
                          sx={{
                            height: 197,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center'
                          }}
                        >
                          <>
                            <StyledTitle
                              // maxWidth={800}
                              sx={{
                                lineHeight: '38px !important',
                                fontSize: '32px !important',
                                textTransform: 'initial !important',
                                margin: '0px auto !important'
                              }}
                              className="messageError-title"
                            >
                              йой!
                            </StyledTitle>
                            <Typography
                              sx={{
                                fontSize: '14px',
                                margin: '5px auto 0px',
                                width: '50%',
                                textAlign: 'center'
                              }}
                            >
                              На жаль, профіль більше не існує
                            </Typography>
                          </>
                        </Grid>
                      </Grid>
                    </Paper>
                  ) : null}
                </>
              )}

              {itemData.length !== 0 && (
                <>
                  {message?.forwardedMessage && (
                    <Grid container sx={{ width: '100%' }} spacing={1}>
                      <Grid item xs={10} sx={{ display: 'flex' }}>
                        <Typography
                          onClick={() =>
                            navigate(
                              `/${language}/user-page/${message.forwardedMessage?.userId}?type=posts`
                            )
                          }
                          variant="body2"
                          sx={{
                            fontSize: '14px',
                            fontWeight: '500',
                            cursor: 'pointer',
                            fontFamily: 'FixelText-Medium',
                            color: '#7C7C7C'
                          }}
                        >{`@${message.forwardedMessage?.nickname}`}</Typography>
                      </Grid>

                      {/* <Grid item sx={{ width: '41px' }} /> */}
                    </Grid>
                  )}{' '}
                  <ImageList
                    sx={{
                      // width: { xs: '250px', sm: '300px' },
                      // height: 'max-content',
                      mt: 0
                    }}
                    variant="quilted"
                    cols={6}
                    rowHeight={40}
                  >
                    {itemData.map((item, index) => (
                      <ImageListItem
                        onClick={() => {
                          setSliderStartIdx(index);
                          setShowedImg(itemData);
                          dispatch(setIsOpenFullscreenPicture(true));
                        }}
                        key={item.img + index}
                        cols={item.cols || 1}
                        rows={item.rows || 1}
                      >
                        <img
                          style={{
                            borderRadius: '5px',
                            maxHeight: '50% !important',
                            maxWidth: '50vh !important'
                          }}
                          {...srcset(item.img, 50, item.rows, item.cols)}
                          alt={item.title}
                        />
                      </ImageListItem>
                    ))}
                  </ImageList>
                </>
              )}
              {message?.forwardedMessage?.abstractMessageWithDTO?.type === 'user' ||
              message?.forwardedMessage?.abstractMessageWithDTO?.type === 'service' ||
              message?.forwardedMessage?.abstractMessageWithDTO?.type === 'post' ? (
                <>
                  <Grid container sx={{ width: '100%' }} spacing={1}>
                    <Grid item xs={10} sx={{ display: 'flex' }}>
                      <Typography
                        onClick={() =>
                          navigate(
                            `/${language}/user-page/${message.forwardedMessage?.userId}?type=posts`
                          )
                        }
                        variant="body2"
                        sx={{
                          fontSize: '14px',
                          fontWeight: '500',
                          cursor: 'pointer',
                          color: '#7C7C7C',
                          fontFamily: 'FixelText-Medium'
                        }}
                      >{`@${message.forwardedMessage?.nickname}`}</Typography>
                    </Grid>

                    {/* <Grid item sx={{ width: '41px' }} /> */}
                  </Grid>
                  {message?.forwardedMessage?.abstractMessageWithDTO?.type === 'user' && (
                    // <Grid item xs={10}>
                    <Paper
                      sx={{
                        p: '0px 0px 10px',
                        backgroundColor: 'transparent',
                        minWidth: { xs: '250px', sm: '270px' },
                        mr: 'auto'
                      }}
                    >
                      <UserCard
                        el={message?.forwardedMessage?.abstractMessageWithDTO?.userDTO}
                        noWidth={true}
                      />
                    </Paper>
                  )}
                  {message?.forwardedMessage?.abstractMessageWithDTO?.type === 'service' && (
                    <Paper sx={{ p: '0px 0px 10px', mr: 'auto', backgroundColor: 'transparent' }}>
                      <ServiceCard
                        isServicePage={true}
                        el={message?.forwardedMessage?.abstractMessageWithDTO?.servicePostDTO}
                      />
                    </Paper>
                  )}
                  {message?.forwardedMessage?.abstractMessageWithDTO?.type === 'post' && (
                    <Paper sx={{ p: '0px 0px 10px', mr: 'auto', backgroundColor: 'transparent' }}>
                      <PostCard
                        el={message?.forwardedMessage?.abstractMessageWithDTO?.postDTO}
                        isChat={true}
                      />
                    </Paper>
                  )}
                </>
              ) : null}
              {(message?.text.length > 0 || message?.forwardedMessage) && (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%'

                    // flexDirection:itemData.length!==0?'column':'row'
                  }}
                >
                  {' '}
                  <Grid
                    container
                    sx={{
                      background: includedObject || message?.forwardedMessage ? '#F5F4F4' : 'none',
                      p: includedObject || message?.forwardedMessage ? '8px' : '0px',
                      borderRadius:
                        includedObject || message?.forwardedMessage ? '8px 8px 8px 0px' : '0px'
                    }}
                  >
                    {message.forwardedMessage && (
                      <Grid
                        container
                        sx={{
                          width: '100%',
                          backgroundColor: 'rgba(255,255,255,0.7)',
                          borderRadius: '8px',
                          ml: 0,
                          mt: 0
                        }}
                        spacing={1}
                      >
                        {!message?.forwardedMessage?.abstractMessageWithDTO?.photoUrls &&
                          message?.forwardedMessage?.abstractMessageWithDTO?.type !== 'user' &&
                          message?.forwardedMessage?.abstractMessageWithDTO?.type !== 'service' &&
                          message?.forwardedMessage?.abstractMessageWithDTO?.type !== 'post' && (
                            <>
                              <Grid item xs={10} sx={{ display: 'flex' }}>
                                <Typography
                                  onClick={() =>
                                    navigate(
                                      `/${language}/user-page/${message.forwardedMessage.userId}?type=posts`
                                    )
                                  }
                                  variant="body2"
                                  sx={{
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    cursor: 'pointer',
                                    fontFamily: 'FixelText-Medium',
                                    color: '#7C7C7C'
                                  }}
                                >{`@${message.forwardedMessage.nickname}`}</Typography>
                                <Grid item sx={{ width: '39px' }} />
                              </Grid>
                            </>
                          )}
                        {message.forwardedMessage.abstractMessageWithDTO.text.length !== 0 ? (
                          <Grid
                            item
                            xs={10}
                            sx={{
                              wordBreak: 'break-word',
                              fontSize: '14px',

                              pb: 1,
                              mb: 1
                            }}
                          >
                            {message.forwardedMessage.abstractMessageWithDTO.text}
                          </Grid>
                        ) : null}
                      </Grid>
                    )}
                    <Grid
                      item
                      sx={
                        !message.forwardedMessage ||
                        (message?.forwardedMessage &&
                          message?.forwardedMessage?.abstractMessageWithDTO?.type === 'user') ||
                        message?.forwardedMessage?.abstractMessageWithDTO?.type === 'service' ||
                        message?.forwardedMessage?.abstractMessageWithDTO?.type === 'post' ||
                        message?.forwardedMessage?.abstractMessageWithDTO?.photoUrls
                          ? { display: 'none' }
                          : { width: '30px' }
                      }
                    />
                    {message.text.length !== 0 && (
                      <Grid item xs={12}>
                        <Typography
                          variant="body2"
                          sx={{ fontSize: '14px', wordBreak: 'break-word' }}
                        >
                          {message.text}
                        </Typography>
                      </Grid>
                    )}
                    {message?.isChanged && (
                      <Grid item xs={12}>
                        <Typography
                          variant="body2"
                          sx={{
                            fontSize: { xs: '12px', sm: '14px' },
                            wordBreak: 'break-word',
                            textAlign: 'right',
                            color: '#7C7C7C'
                          }}
                        >
                          (редаговано)
                        </Typography>
                      </Grid>
                    )}
                  </Grid>
                </Box>
              )}

              <>
                <MoreHoriz
                  onClick={(event) => handleClick(event)}
                  sx={{
                    ml: 1,
                    cursor: 'pointer',
                    ':hover': { color: '#60A5DF' },
                    zIndex: '99',
                    fontSize: '24px',
                    position: 'absolute',
                    right: '-60px',
                    bottom: '0px',
                    borderRadius: '50px',
                    p: '3px',
                    boxShadow: ' 0px 0px 15px -5px #00000026'
                  }}
                />
                <ReplyIcon
                  sx={{ position: 'absolute', right: '-30px', bottom: '0px', cursor: 'poiner' }}
                  onClick={(event) => {
                    event.stopPropagation();
                    event.preventDefault();
                    setIsEditMessage(true);
                    setIsSendingPic(false);
                    setIsReplyMessage(true);
                    setIsResendMessage(false);
                    setText('');
                    setMessageSelected(message.id);
                    handleClose();
                  }}
                />
                <Menu
                  anchorEl={anchorEl}
                  id="action-menu"
                  open={open}
                  onClose={handleClose}
                  onMouseLeave={handleClose}
                  PaperProps={{
                    elevation: 0,
                    sx: {
                      overflow: 'hidden',

                      borderRadius: '5px',
                      boxShadow: '0px 0px 15px -5px #00000026',
                      paddingTop: '10px',
                      paddingLeft: '20px',
                      paddingRight: '20px',
                      width: '200px',
                      mt: 1
                    }
                  }}
                  autoFocus={false}
                  transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                  anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                >
                  <MenuItem
                    onClick={(event) => {
                      event.stopPropagation();
                      event.preventDefault();
                      setIsEditMessage(true);
                      setIsReplyMessage(true);
                      setIsResendMessage(false);
                      handleClose();
                    }}
                    sx={{
                      borderRadius: '4px',
                      ':hover': { backgroundColor: '#E2F2FF' },
                      fontFamily: 'FixelText-Medium',
                      fontWeight: '500',
                      pl: '12px !important',
                      m: '2px 0px !important'
                    }}
                  >
                    {/*<ReplyIcon sx={{ color: '#60A5DF', mr: 1 }} />*/}
                    <Typography component="p" fontSize={16} lineHeight="18px" fontWeight={400}>
                      Відповісти
                    </Typography>
                  </MenuItem>
                  <MenuItem
                    onClick={(event) => {
                      event.stopPropagation();
                      event.preventDefault();
                      dispatch(
                        setIsOpenResendingModal({
                          isOpen: true,
                          id: null,
                          type: null,
                          func: setUsersForResending
                        })
                      );
                      setIsEditMessage(false);
                      setIsResendMessage(true);
                      setIsReplyMessage(false);
                      handleClose();
                    }}
                    sx={{
                      borderRadius: '4px',
                      ':hover': { backgroundColor: '#E2F2FF' },
                      fontFamily: 'FixelText-Medium',
                      fontWeight: '500',
                      pl: '12px !important',
                      m: '2px 0px !important'
                    }}
                  >
                    <Typography component="p" fontSize={16} lineHeight="18px" fontWeight={400}>
                      Відправити
                    </Typography>
                  </MenuItem>
                </Menu>
              </>
            </Box>
            <Typography
              variant="body2"
              sx={{
                fontSize: '12px',
                fontFamily: 'FixelText-Regular',
                color: '#7C7C7C',
                marginLeft: 'auto',
                marginTop: '0',
                position: 'absolute',
                bottom: '-15px',
                left: '10px'
              }}
            >
              {timeFormattingByDate(new Date(message.sendingTime))}
            </Typography>
          </Grid>
          <Grid item xs={2} sm={6} />
        </Grid>
      )}
    </React.Fragment>
  );
}

export default memo(ChatMessage);
